import { render, staticRenderFns } from "./YaopinForm.vue?vue&type=template&id=33cff94d&"
import script from "./YaopinForm.vue?vue&type=script&lang=js&"
export * from "./YaopinForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports